exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".styles__appContainer___3bKvm{min-height:100%;position:relative;padding-bottom:50px}.styles__appContainer___3bKvm .styles__mainContainer___2Iu8R{max-width:980px;margin:2rem auto 5rem;padding:1.5rem}", "", {"version":3,"sources":["/app/qa/frontend/src/layouts/CoreLayout/styles.scss"],"names":[],"mappings":"AAAA,8BACI,gBAAgB,kBACE,mBACE,CAHxB,6DAMQ,gBAAgB,sBACM,cACP,CAClB","file":"styles.scss","sourcesContent":[".appContainer {\n    min-height: 100%;\n    position: relative;\n    padding-bottom: 50px;\n\n    .mainContainer {\n        max-width: 980px;\n        margin: 2rem auto 5rem;\n        padding: 1.5rem;\n    }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"appContainer": "styles__appContainer___3bKvm",
	"mainContainer": "styles__mainContainer___2Iu8R"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true,"minimize":false,"modules":true,"importLoaders":1,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/postcss-loader/lib?{"plugins":[{"version":"5.2.18","plugins":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],"postcssPlugin":"cssnano","postcssVersion":"5.2.18"}],"sourceMap":true}!./~/sass-loader/lib/loader.js?{"sourceMap":true,"includePaths":["/app/qa/frontend/src/styles"]}!./src/layouts/CoreLayout/styles.scss
// module id = 237
// module chunks = 0